import { memo, useEffect, useState } from 'react'
import { PROCESS_ACTIVITY_STATUSES } from '../../utility/constants'
import { Button, MenuItem, TextField } from '@mui/material'
import _ from 'lodash'
import { userConfig } from '../../services/userConfigServices'
import { useAuthContext } from '../../hooks/useAuthContext'
import { getFieldId } from '../../pages/DataEntryPage/utils/utils'
import { constraintValidationWithOperation } from '../../pages/DataEntryPage/utils/validationUtil'
import { useResponsiveTypography } from '../../utility/responsiveTypography'
const DataEntryFormFooter = memo(
  ({
    currentPageNum,
    totalPage,
    pageData,
    processActivityStatus,
    setOverallCommentsOpen,
    setSubmissionDialogOpen,
    handleAllReviewValuesLoading,
    toRoutes,
    selectedToRoute,
    setSelectedToRoute,
    classes,
    processReferenceNum,
    allValues,
    fieldConstraintHiddenRoutes,
  }) => {
    const { user } = useAuthContext()
    const [routes, setRoutes] = useState([])
    const [hiddenRouteIds, setHiddenRouteIds] = useState([])
    const { goButton } = useResponsiveTypography()
    useEffect(() => {
      if (processReferenceNum) {
        ;(async () => {
          const hiddenRoutes = await userConfig.getHiddenRoutesConfig(user, processReferenceNum)
          const hiddenRouteIds = hiddenRoutes.data.map((it) => it.hidden_route_template_id)
          setHiddenRouteIds(hiddenRouteIds)
          setRoutes(
            toRoutes.filter((it) => {
              const index = hiddenRouteIds.findIndex((id) => id == it.id)
              return index == -1
            })
          )
        })()
      }
    }, [toRoutes, processReferenceNum])

    useEffect(() => {
      let fieldConstraintValidHiddenRoutes = []
      let fieldConstrainHiddenRouteIds = []
      fieldConstraintHiddenRoutes.forEach((fchr) => {
        const fieldTemplateValue = allValues[getFieldId(fchr.field_template_id)]
        const relatedFieldTemplateValue = allValues[getFieldId(fchr.related_field_template_id)]
        const isHiddenFieldConstraintValid = constraintValidationWithOperation(
          fieldTemplateValue,
          fchr.constant_value || relatedFieldTemplateValue,
          fchr.constraint
        )

        fieldConstrainHiddenRouteIds.push(fchr.hidden_route_template_id)
        if (isHiddenFieldConstraintValid) {
          fieldConstraintValidHiddenRoutes.push(fchr.hidden_route_template_id)
        }
      })
      let updatedHiddenRoutes = []
      if (fieldConstraintValidHiddenRoutes.length > 0) {
        updatedHiddenRoutes = [...hiddenRouteIds, ...fieldConstraintValidHiddenRoutes]
      } else {
        updatedHiddenRoutes = hiddenRouteIds.filter(
          (id) => !fieldConstrainHiddenRouteIds.includes(id)
        )
      }
      setHiddenRouteIds([...updatedHiddenRoutes])
      setRoutes(
        toRoutes.filter((it) => {
          const index = updatedHiddenRoutes.findIndex((id) => id == it.id)
          return index == -1
        })
      )
    }, [allValues])

    useEffect(() => {
      if (hiddenRouteIds.includes(selectedToRoute) && routes.length > 0) {
        setSelectedToRoute(routes[0]?.id)
      }
    }, [hiddenRouteIds, selectedToRoute, routes])

    return (
      <div
        style={
          !(currentPageNum == (totalPage || pageData?.length)) ||
          processActivityStatus === PROCESS_ACTIVITY_STATUSES.CLOSED
            ? { display: 'none' }
            : goButton
        }
      >
        <Button
          className="Go-btn"
          color="primary"
          variant="contained"
          type="button"
          onClick={() => {
            if (setSubmissionDialogOpen) {
              setSubmissionDialogOpen(true)
            } else {
              setOverallCommentsOpen(true)
            }
          }}
          disabled={handleAllReviewValuesLoading}
        >
          Go
        </Button>
        &nbsp;&nbsp;
        {routes && selectedToRoute && (
          <>
            <TextField
              select
              color="primary"
              variant="outlined"
              label="Vote"
              sx={{
                '& .MuiInputBase-root': {
                  height: 40,
                },
              }}
              className={classes.fields}
              onChange={(e) => {
                setSelectedToRoute(e.target.value)
              }}
              value={selectedToRoute}
              disabled={false}
            >
              {routes.map((route) => (
                <MenuItem key={route.id} value={route.id}>
                  {route.route_template_name}
                </MenuItem>
              ))}
            </TextField>
          </>
        )}
      </div>
    )
  }
)
export default DataEntryFormFooter
